import { setContext } from "@apollo/client/link/context";

import { handleTokenExpiration, isTokenExpired } from "../../utils";
import { StorageKey } from "../../types";

export const authLink = setContext((_, context) => {
  const token = localStorage.getItem(StorageKey.Token);

  if (token && isTokenExpired(token)) {
    handleTokenExpiration();
  }

  return {
    headers: {
      ...context.headers,
      Authorization: token && !isTokenExpired(token) ? `Bearer ${token}` : "",
      "x-fm-device-platform": "web",
    },
  };
});
